'use client';

import React from 'react';
import { Wallet } from '@velocity-exchange/icons';
import MarketIcon from '../../Utils/MarketIcon';
import { EarnProductsByAsset } from 'src/hooks/useEarnProduct';
import { PointsMono } from '@velocity-exchange/icons';
import { useEarnProductByAssetData } from 'src/hooks/useEarnProductByAssetData';
import { EarnProductMobile } from './EarnProductMobile';
import { getColorVar } from 'src/utils/theme/colorVars';
import MobileTableCard from 'src/components/Tables/cards/MobileTableCard';
import PresetTag from 'src/components/Tags/PresetTag';

interface EarnProductByAssetMobileProps {
	info: EarnProductsByAsset;
}

export const EarnProductByAssetMobile: React.FC<
	EarnProductByAssetMobileProps
> = ({ info }) => {
	const {
		showAccordion,
		walletIsConnected,
		handleToggleExpanded,
		shouldShowWalletBalance,
		getWalletBalance,
		aprStr,
	} = useEarnProductByAssetData(info);

	return (
		<MobileTableCard.Root
			expanded={showAccordion}
			setExpanded={handleToggleExpanded}
		>
			<MobileTableCard.CollapsibleHeader expanded={showAccordion}>
				<div className="inline-flex min-h-[40px] flex-1 items-center">
					<MarketIcon
						sizeClass="size-2xl"
						marketSymbol={info.spotMarket.symbol}
					/>
					<div className="mr-md space-y-2xs pl-lg">
						<div className="flex items-center gap-sm">
							<div className="typo-label-md text-text-default">
								{info.spotMarket.symbol}
							</div>
							{info.isNew && <PresetTag preset="new" />}
						</div>

						{walletIsConnected &&
							shouldShowWalletBalance(info.spotMarket.symbol) && (
								<div className="flex items-center gap-xs text-text-secondary">
									<Wallet />
									<div className="block typo-body-xs">
										{getWalletBalance(info.spotMarket.symbol)}
									</div>
								</div>
							)}
					</div>
				</div>

				<div className="flex items-center justify-end text-end">
					<div className="flex flex-col gap-2xs">
						<div className="text-right typo-body-xs text-text-tertiary">
							{!(
								info.highestApyProductType === 'strategy_vaults' &&
								info.apyToShow > 30
							)
								? 'Up to'
								: ''}
						</div>
						<div className="flex items-center gap-xs">
							{info.isPromo && (
								<PointsMono size={16} color={getColorVar('purple-link')} />
							)}
							<div className="typo-label-md text-text-positive-green-button">
								{aprStr}
							</div>
						</div>
					</div>
				</div>
			</MobileTableCard.CollapsibleHeader>

			<MobileTableCard.CollapsibleContent>
				{info.accordionOptions.map((option, optionIndex) => {
					if (option.marketIndex === undefined) {
						return null;
					}
					return (
						<EarnProductMobile
							key={`option_${optionIndex}_${info.spotMarket.symbol}`}
							earnProduct={option}
							showDetails={false}
						/>
					);
				})}
			</MobileTableCard.CollapsibleContent>
		</MobileTableCard.Root>
	);
};
